'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var session = require('../session/session.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Http {
  constructor(url, brand, key, driver) {
    this.url = url;
    this.brand = brand;
    this.key = key;
    this.driver = driver;
    this.baseUrl = `${this.url}/igc/${this.brand}`;
    if (this.driver === void 0) {
      if (typeof fetch === "undefined") {
        throw new Error('No http driver is passed and "fetch" is not available');
      }
      this.driver = fetch.bind();
    }
  }
  request(endpoint, params) {
    return __async(this, null, function* () {
      const resp = yield this.driver(this.makeUrl(endpoint), {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-API-Key": this.key,
          "X-API-Session-Id": session.session.getId() || ""
        },
        body: JSON.stringify(params),
        cache: "no-cache"
      });
      const result = yield resp.json();
      if (result.err) {
        throw result.err;
      }
      return result.res;
    });
  }
  upload(endpoint, files, onProgressChange, params) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      const data = new FormData();
      const paramKeys = params ? Object.keys(params) : [];
      paramKeys.forEach((key) => data.append(key, params[key]));
      let fileCount = 1;
      if (files instanceof FileList) {
        Array.from(files).forEach((file, i) => {
          data.append(`file${i}`, file);
        });
        fileCount = files.length;
      } else {
        data.append("file0", files);
      }
      const handleError = (error) => {
        reject(error);
        if (onProgressChange) {
          onProgressChange(0, true);
        }
      };
      request.addEventListener("load", () => {
        try {
          const response = JSON.parse(request.response);
          if (!response || !response.res || !response.res.success) {
            handleError(new Error("Unexpected server response on file upload: " + request.response));
          }
          if (onProgressChange) {
            onProgressChange(1, false);
          }
          resolve();
        } catch (e) {
          handleError(e);
        }
      });
      request.addEventListener("abort", handleError);
      request.addEventListener("error", handleError);
      request.addEventListener("timeout", handleError);
      request.upload.addEventListener("progress", (e) => {
        if (onProgressChange) {
          onProgressChange(e.loaded / e.total, false);
        }
      });
      request.open("POST", this.makeUrl(endpoint) + `?fieldsQty=${paramKeys.length}&filesQty=${fileCount}`);
      request.setRequestHeader("X-API-Key", this.key);
      request.setRequestHeader("X-API-Session-Id", session.session.getId() || "");
      request.send(data);
    });
  }
  get(url) {
    return this.driver(url).then((res) => res.text());
  }
  makeUrl(endpoint) {
    return `${this.baseUrl}/${endpoint}`;
  }
}

exports.Http = Http;
